import BankAccountVerification from './BankAccountVerification';
import ListWrapper from '../ListWrapper';

export default function OtherDocumentsTab() {
  return (
    <ListWrapper direction="column">
      <BankAccountVerification />
    </ListWrapper>
  );
}
